import { AppointmentID } from "./Appointment";
import { UserID } from "./User";

export type AppointmentLogID = number;

export enum APPOINTMENT_LOG_TYPES {
  CustomerOwnerChanged = 1
}

export interface AppointmentLog {
  created_on: string;
  id: AppointmentLogID;
  appointment_id: AppointmentID; // Appointment Identifier
  appointment_log_type_id: APPOINTMENT_LOG_TYPES; // Type of the log entry
  user_id: UserID | null; // User Identifier who created the log entry
  user_name: string; // Name of the user who created the log entry
  note: string; // Note containing details of the log entry
}
